<template>
  <div class="top5-table__container">
    <div class="top5-table__toolbar">
      <span class="top5-table__title">Top 5 Suspicious Domains</span>
      <!-- UR-06 AC#8: View All membuka Review Domain dengan filter All Status (navigasi dilakukan parent) -->
      <a href="/dashboard/domain-detection/review-domain" class="top5-table__view-all"
        @click.prevent="$emit('viewAll')">View All</a>
    </div>

    <hr class="top5-table__divider" />

    <div style="overflow-x: auto">
      <table class="table scan-history-table" style="margin: 0">
        <thead>
          <tr>
            <th>Domain</th>
            <th>Total Scan</th>
            <th>First Scan</th>
            <!-- <th>Location</th> -->
            <th>District</th>
            <th>Risk Score</th>
            <th>Domain Status</th>
            <th style="width: 200px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="7" class="text-center text-muted py-3" style="font-size: 13px">Loading...</td>
          </tr>
          <template v-else>
            <tr v-for="(item, idx) in items" :key="idx">
              <td class="domain-cell">{{ item.domain }}</td>
              <td>{{ numberWithCommas(item.totalScan) }}</td>
              <td>{{ item.firstScan }}</td>
              <!-- <td>{{ item.location }}</td> -->
              <td>{{ item.district }}</td>
              <td>
                <span class="top5-table__badge" :class="riskClass(item.riskScore)">
                  {{ capitalize(item.riskScore) }}
                </span>
              </td>
              <td>
                <span class="top5-table__badge top5-table__badge--status" :class="statusClass(item.domainStatus)">
                  {{ statusLabel(item.domainStatus) }}
                </span>
              </td>
              <td>
                <div class="top5-table__actions">
                  <button v-if="isWatchlistable(item.domainStatus)" class="top5-table__btn top5-table__btn--watchlist"
                    @click="$emit('watchlist', item)">Watchlist</button>
                  <button v-if="canManageIgnore && isIgnorable(item.domainStatus)"
                    class="top5-table__btn top5-table__btn--ignore" @click="$emit('ignore', item)">Ignore</button>
                  <button class="top5-table__btn top5-table__btn--detail" @click="$emit('detail', item)">Detail</button>
                </div>
              </td>
            </tr>
            <tr v-if="!items.length">
              <td colspan="7" class="text-center text-muted py-3" style="font-size: 13px">No data available</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import qs from "qs";

export default {
  name: "DomainSummaryTop5Table",
  props: {
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    province: { type: String, default: null },
    region: { type: String, default: null },
    district: { type: String, default: null },
    domain: { type: String, default: null },
  },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  computed: {
    // Samakan dengan Review Domain: API hanya bisa diakses ADMIN & SUPER ADMIN.
    canManageIgnore() {
      return true;
    },
  },
  watch: {
    startDate() {
      this.fetchData();
    },
    endDate() {
      this.fetchData();
    },
    province() {
      this.fetchData();
    },
    region() {
      this.fetchData();
    },
    district() {
      this.fetchData();
    },
    domain() {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const params = qs.stringify(
          {
            start_date: this.startDate,
            end_date: this.endDate,
            domain: this.domain,
            province: this.province,
            region: this.region,
            district: this.district,
          },
          { skipNulls: true },
        );
        const resp = await this.$http.get(`/api/domain-detection-summary/top-5-suspicious-domain-list?${params}`);
        this.items = resp.data.data.map((d) => ({
          domainId: d.domain_id,
          domain: d.domain_url,
          totalScan: d.total_scan,
          firstScan: d.first_scan ? d.first_scan.replace(" ", " | ") : "-",
          location: d.total_region,
          district: d.total_district,
          riskScore: d.risk_score,
          domainStatus: d.domain_status,
          isPublicPlatform: !!d.is_public_platform, // dari BE (BR-09), dipakai modal Ignore
        }));
      } catch (e) {
        this.errorPrint(e);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    riskClass(score) {
      if (!score) return "";
      const s = score.toLowerCase();
      if (s === "high") return "top5-table__badge--high";
      if (s === "medium") return "top5-table__badge--medium";
      if (s === "low") return "top5-table__badge--low";
      return "";
    },
    statusClass(status) {
      if (!status) return "";
      // API mengirim "under_review"
      const s = status.toLowerCase().replace(/[\s-]+/g, "_");
      if (s === "under_review") return "top5-table__badge--under-review";
      if (s === "watchlisted") return "top5-table__badge--watchlisted";
      if (s === "dismissed") return "top5-table__badge--dismissed";
      if (s === "ignored") return "top5-table__badge--ignored";
      return "";
    },
    statusLabel(status) {
      if (!status) return "";
      // "under_review" -> "Under Review"
      return status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    },
    isWatchlistable(status) {
      if (!status) return true;
      const s = status.toLowerCase();
      return s !== "watchlisted" && s !== "dismissed" && s !== "ignored";
    },
    // Top 5 hanya berisi Under Review / Watchlisted, tapi tetap dijaga bila ada status lain.
    isIgnorable(status) {
      return !status || status.toLowerCase() !== "ignored";
    },
  },
};
</script>

<style scoped>
.top5-table__container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
}

.top5-table__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top5-table__title {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

.top5-table__view-all {
  font-size: 11px;
  color: #2196f3;
  text-decoration: underline;
}

.top5-table__divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0;
}

.scan-history-table thead th {
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #9d9d9d !important;
  border-top: 1px solid #e6e6e6;
  white-space: nowrap;
  padding: 10px 8px;
}

.scan-history-table tbody td {
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #393939 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  border-top: none !important;
  vertical-align: middle;
  padding: 10px 8px;
}

.domain-cell {
  word-break: break-all;
  overflow-wrap: anywhere;
  max-width: 300px;
  min-width: 160px;
}

.scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Badge: samakan nilainya dengan ReviewDomain.vue */
.top5-table__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06px;
  white-space: nowrap;
}

.top5-table__badge--high { background: #D0202E; color: #fff; }
.top5-table__badge--medium { background: #FDB022; color: #fff; }
.top5-table__badge--low { background: #12B76A; color: #fff; }

/* Badge Domain Status: border radius terpisah dari Risk Score */
.top5-table__badge--status { border-radius: 3px; }

.top5-table__badge--under-review { background: #FFF4e8; color: #a04a00; }
.top5-table__badge--watchlisted { background: #FDEEEE; color: #B3141f; }
.top5-table__badge--dismissed { background: #FAFAFA; color: #4B4B4B; }
.top5-table__badge--ignored { background: #eceef1; color: #3f4753; }

.top5-table__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.top5-table__btn {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
}

.top5-table__btn--watchlist {
  background: #267ce5;
  color: #fff;
}
.top5-table__btn--detail {
  background: #fff;
  color: #4b4b4b;
}
.top5-table__btn--ignore {
  background: #fff;
  color: #d92d20;
  border: 1px solid #fda29b;
}
</style>